import { AxiosResponse } from 'axios'
import { inject, InjectionKey, ref } from 'vue'
import { User } from '../../../libs/models'
import { useApi } from '../libs/api'

export interface CurrentUserStore {
  readonly value: User | null
  fetch: () => Promise<User | null>,
  create: (nickname: string) => Promise<User>,
  update: (data: { name: string, desc: string | null, illustId: number | null }) => Promise<User | null>,
  updatePassword: (password: string) => Promise<User | null>,
  enter: (roomId: number, code?: string) => Promise<User | null>,
  leave: () => Promise<User | null>,
  signin: (token: string) => Promise<User>,
  signinWithPassword: (userId: string, password: string) => Promise<User>
}
export const generateCurrentUserStore = (): CurrentUserStore => {
  const user = ref<User | null>(null)
  const api = useApi()
  const fetch = (): Promise<User | null> => {
    return api.get('/users/current').then(({ data }: AxiosResponse<User | null>) => {
      if (data) user.value = data
      return user.value
    })
  }
  const create = (nickname: string) => {
    return api.post(`/users`, { name: nickname }).then(({ data }: AxiosResponse<User>) => {
      user.value = data
      return data
    })
  }
  const update = async (data: { name: string, desc: string | null, illustId: number | null }) => {
    if (!user.value) return null
    const payload = {
      name: data.name,
      desc: data.desc,
      illust_id: data.illustId
    }
    return api.post(`/users/${user.value.id}`, payload).then(({ data }: AxiosResponse<User>) => {
      user.value = data
      return data
    })
  }
  const updatePassword = async (password: string) => {
    if (!user.value) return null
    console.log(password)
    return api.post(`/users/${user.value.id}`, { password }).then(({ data }: AxiosResponse<User>) => {
      user.value = data
      return data
    })
  }
  const enter = (roomId: number, code?: string) => {
    return api.post(`/rooms/${roomId}/enter`, {}, { params: { code: code } }).then(() => {
      return fetch()
    })
  }
  const signin = (token: string) => {
    return api.post('/signin', { token }).then(({ data }: AxiosResponse<User>) => {
      user.value = data
      return data
    })
  }
  const signinWithPassword = (userId: number | string, password: string) => {
    return api.post(`/signin/${userId}`, { password }).then(({ data }: AxiosResponse<User>) => {
      user.value = data
      return data
    })
  }
  const leave = () => {
    return api.post('/leave').then(() => {
      return fetch()
    })
  }
  return {
    get value () {
      return user.value
    },
    fetch,
    create,
    enter,
    update,
    updatePassword,
    leave,
    signin,
    signinWithPassword
  }
}
export const currentUserStoreKey: InjectionKey<CurrentUserStore> = Symbol()
export const useCurrentUserStore = (): CurrentUserStore => {
  const currentUserStore = inject(currentUserStoreKey)
  if (!currentUserStore) throw Error('Could not inject currentUserStore')
  return currentUserStore
}
